import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addDepartmentHr = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Department',
    body
  );
  return data;
});
export const updateDepartmentHr = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Department/${id}`,
    body
  );
  return data;
});

export const getDepartmentHr = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Department?fields=["name","department_name","parent_department","disabled"]'
  );
  return data;
});
export const deleteDepartmentHr = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Department/${record}`
  );
  return data;
});
export const getDepartmentHrDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Department/${id}`
  );
  return data;
});
